import Store from '../store/tournaments';

export const initialState = Store;

const checkRange = (value, from, to) => {
  if (from !== null && to !== null) return value >= from && value <= to;
  if (from !== null) return value >= from;
  if (to !== null) return value <= to;
  return true;
};

export default function tournamentsReducer(state = initialState, action) {
  switch (action.type) {
    case 'TOURNAMENTS_REPLACE': {
      const tournaments = [];
      let hasActiveRegistration = false;


      Object.keys(action.data).map((key) => {
        tournaments.push({ ...action.data[key], id: key });
        if (action.data[key] && action.data[key].currentState && action.data[key].currentState === 'registration' && !hasActiveRegistration) {
          if (action.data[key].restrictions) {
            const {
              lvl, bal, totalPnts, gPlayed,
            } = action.userData;
            const levelFrom = (action.data[key].levelFrom || action.data[key].levelFrom === 0) ? parseInt(action.data[key].levelFrom, 10) : null;
            const levelTo = (action.data[key].levelTo || action.data[key].levelTo === 0) ? parseInt(action.data[key].levelTo, 10) : null;
            const pointsFrom = (action.data[key].pointsFrom || action.data[key].pointsFrom === 0) ? parseInt(action.data[key].pointsFrom, 10) : null;
            const pointsTo = (action.data[key].pointsTo || action.data[key].pointsTo === 0) ? parseInt(action.data[key].pointsTo, 10) : null;
            const balanceFrom = (action.data[key].balanceFrom || action.data[key].balanceFrom === 0) ? parseInt(action.data[key].balanceFrom, 10) : null;
            const balanceTo = (action.data[key].balanceTo || action.data[key].balanceTo === 0) ? parseInt(action.data[key].balanceTo, 10) : null;
            const playedGamesFrom = (action.data[key].playedGamesFrom || action.data[key].playedGamesFrom === 0) ? parseInt(action.data[key].playedGamesFrom, 10) : null;
            const playedGamesTo = (action.data[key].playedGamesTo || action.data[key].playedGamesTo === 0) ? parseInt(action.data[key].playedGamesTo, 10) : null;

            const isLevelPass = checkRange(lvl, levelFrom, levelTo);
            const isPointsPass = checkRange(totalPnts, pointsFrom, pointsTo);
            const isBalPass = checkRange(bal, balanceFrom, balanceTo);
            const isPlayedGamesPass = checkRange(gPlayed, playedGamesFrom, playedGamesTo);

            if (isLevelPass && isPointsPass && isBalPass && isPlayedGamesPass) {
              hasActiveRegistration = true;
            }
          } else {
            hasActiveRegistration = true;
          }
        }
        return null;
      });

      tournaments.sort((a, b) => {
        const aIsRegistration = a.currentState === 'registration';
        const bIsRegistration = b.currentState === 'registration';

        if (aIsRegistration && !bIsRegistration) return -1;
        if (!aIsRegistration && bIsRegistration) return 1;

        return b.startDate - a.startDate;
      });

      return {
        ...state,
        tournaments,
        hasActiveRegistration,
      };
    }

    case 'TOURNAMENTS_REPLACE_MOBILE': {
      const tournaments = [];
      let hasActiveRegistration = false;


      Object.keys(action.data).map((key) => {
        tournaments.push({ ...action.data[key], id: key });
        if (action.data[key] && action.data[key].currentState && action.data[key].currentState === 'registration' && !hasActiveRegistration) {
          if (action.data[key].restrictions) {
            const {
              lvl, bal, totalPnts, gPlayed,
            } = action.userData;
            const levelFrom = (action.data[key].levelFrom || action.data[key].levelFrom === 0) ? parseInt(action.data[key].levelFrom, 10) : null;
            const levelTo = (action.data[key].levelTo || action.data[key].levelTo === 0) ? parseInt(action.data[key].levelTo, 10) : null;
            const pointsFrom = (action.data[key].pointsFrom || action.data[key].pointsFrom === 0) ? parseInt(action.data[key].pointsFrom, 10) : null;
            const pointsTo = (action.data[key].pointsTo || action.data[key].pointsTo === 0) ? parseInt(action.data[key].pointsTo, 10) : null;
            const balanceFrom = (action.data[key].balanceFrom || action.data[key].balanceFrom === 0) ? parseInt(action.data[key].balanceFrom, 10) : null;
            const balanceTo = (action.data[key].balanceTo || action.data[key].balanceTo === 0) ? parseInt(action.data[key].balanceTo, 10) : null;
            const playedGamesFrom = (action.data[key].playedGamesFrom || action.data[key].playedGamesFrom === 0) ? parseInt(action.data[key].playedGamesFrom, 10) : null;
            const playedGamesTo = (action.data[key].playedGamesTo || action.data[key].playedGamesTo === 0) ? parseInt(action.data[key].playedGamesTo, 10) : null;

            const isLevelPass = checkRange(lvl, levelFrom, levelTo);
            const isPointsPass = checkRange(totalPnts, pointsFrom, pointsTo);
            const isBalPass = checkRange(bal, balanceFrom, balanceTo);
            const isPlayedGamesPass = checkRange(gPlayed, playedGamesFrom, playedGamesTo);

            if (isLevelPass && isPointsPass && isBalPass && isPlayedGamesPass) {
              hasActiveRegistration = true;
            }
          } else {
            hasActiveRegistration = true;
          }
        }
        return null;
      });

      tournaments.sort((a, b) => {
        const aIsRegistration = (a.currentState === 'registration' || a.currentState === 'pause' || a.currentState === 'play');
        const bIsRegistration = (b.currentState === 'registration' || b.currentState === 'pause' || b.currentState === 'play');

        if (aIsRegistration && !bIsRegistration) return -1;
        if (!aIsRegistration && bIsRegistration) return 1;

        return a.startDate - b.startDate;
      });

      return {
        ...state,
        tournaments,
        hasActiveRegistration,
      };
    }

    case 'TOURNAMENTS_CHILD_ADDED': {
      const {
        tournaments,
      } = state;
      // let hasActiveRegistration = false;
      let { hasActiveRegistration } = state;

      const { childAddedKey, data } = action;

      const newTournaments/** result */ = tournaments.filter(tournament => tournament.id !== childAddedKey);

      // if (result && result.length) {
      //   return {
      //     ...state,
      //   };
      // }
      // console.log('TOURNAMENTS_CHILD_ADDED', newTournaments, state, action/*, result*/);


      newTournaments.push({ ...data, id: childAddedKey });
      if (data && data.currentState && data.currentState === 'registration' && !hasActiveRegistration) {
        if (data.restrictions) {
          const {
            lvl, bal, totalPnts, gPlayed,
          } = action.userData;
          const levelFrom = (data.levelFrom || data.levelFrom === 0) ? parseInt(data.levelFrom, 10) : null;
          const levelTo = (data.levelTo || data.levelTo === 0) ? parseInt(data.levelTo, 10) : null;
          const pointsFrom = (data.pointsFrom || data.pointsFrom === 0) ? parseInt(data.pointsFrom, 10) : null;
          const pointsTo = (data.pointsTo || data.pointsTo === 0) ? parseInt(data.pointsTo, 10) : null;
          const balanceFrom = (data.balanceFrom || data.balanceFrom === 0) ? parseInt(data.balanceFrom, 10) : null;
          const balanceTo = (data.balanceTo || data.balanceTo === 0) ? parseInt(data.balanceTo, 10) : null;
          const playedGamesFrom = (data.playedGamesFrom || data.playedGamesFrom === 0) ? parseInt(data.playedGamesFrom, 10) : null;
          const playedGamesTo = (data.playedGamesTo || data.playedGamesTo === 0) ? parseInt(data.playedGamesTo, 10) : null;

          const isLevelPass = checkRange(lvl, levelFrom, levelTo);
          const isPointsPass = checkRange(totalPnts, pointsFrom, pointsTo);
          const isBalPass = checkRange(bal, balanceFrom, balanceTo);
          const isPlayedGamesPass = checkRange(gPlayed, playedGamesFrom, playedGamesTo);

          if (isLevelPass && isPointsPass && isBalPass && isPlayedGamesPass) {
            hasActiveRegistration = true;
          }
        } else {
          hasActiveRegistration = true;
        }
      }


      newTournaments.sort((a, b) => {
        const aIsRegistration = a.currentState === 'registration';
        const bIsRegistration = b.currentState === 'registration';

        // If one is registration and the other isn't, registration comes first
        if (aIsRegistration && !bIsRegistration) return -1;
        if (!aIsRegistration && bIsRegistration) return 1;

        // Otherwise, sort by startDate (descending)
        return b.startDate - a.startDate;
      });

      return {
        ...state,
        tournaments: newTournaments,
        hasActiveRegistration,
      };
    }

    case 'TOURNAMENTS_CHILD_CHANGED': {
      const {
        tournaments,
      } = state;
      // let hasActiveRegistration = false;
      let { hasActiveRegistration } = state;
      const { childChangedKey, data } = action;

      const newTournaments = tournaments.filter(tournament => tournament.id !== childChangedKey);
      // // console.log('TOURNAMENTS_CHILD_CHANGED', newTournaments, state, action);

      newTournaments.push({ ...data, id: childChangedKey });

      if (data && data.currentState && data.currentState === 'registration' && !hasActiveRegistration) {
        if (data.restrictions) {
          const {
            lvl, bal, totalPnts, gPlayed,
          } = action.userData;
          const levelFrom = (data.levelFrom || data.levelFrom === 0) ? parseInt(data.levelFrom, 10) : null;
          const levelTo = (data.levelTo || data.levelTo === 0) ? parseInt(data.levelTo, 10) : null;
          const pointsFrom = (data.pointsFrom || data.pointsFrom === 0) ? parseInt(data.pointsFrom, 10) : null;
          const pointsTo = (data.pointsTo || data.pointsTo === 0) ? parseInt(data.pointsTo, 10) : null;
          const balanceFrom = (data.balanceFrom || data.balanceFrom === 0) ? parseInt(data.balanceFrom, 10) : null;
          const balanceTo = (data.balanceTo || data.balanceTo === 0) ? parseInt(data.balanceTo, 10) : null;
          const playedGamesFrom = (data.playedGamesFrom || data.playedGamesFrom === 0) ? parseInt(data.playedGamesFrom, 10) : null;
          const playedGamesTo = (data.playedGamesTo || data.playedGamesTo === 0) ? parseInt(data.playedGamesTo, 10) : null;

          const isLevelPass = checkRange(lvl, levelFrom, levelTo);
          const isPointsPass = checkRange(totalPnts, pointsFrom, pointsTo);
          const isBalPass = checkRange(bal, balanceFrom, balanceTo);
          const isPlayedGamesPass = checkRange(gPlayed, playedGamesFrom, playedGamesTo);

          if (isLevelPass && isPointsPass && isBalPass && isPlayedGamesPass) {
            hasActiveRegistration = true;
          }
        } else {
          hasActiveRegistration = true;
        }
      }

      // console.log('TOURNAMENTS_REPLACE 2', newTournaments);

      newTournaments.sort((a, b) => {
        const aIsRegistration = a.currentState === 'registration';
        const bIsRegistration = b.currentState === 'registration';

        // If one is registration and the other isn't, registration comes first
        if (aIsRegistration && !bIsRegistration) return -1;
        if (!aIsRegistration && bIsRegistration) return 1;

        // Otherwise, sort by startDate (descending)
        return b.startDate - a.startDate;
      });

      return {
        ...state,
        tournaments: newTournaments,
        hasActiveRegistration,
      };
    }

    case 'TOURNAMENTS_CHILD_REMOVED': {
      const {
        tournaments,
      } = state;
      const hasActiveRegistration = false;

      const { childRemovedKey, data } = action;

      const newTournaments = tournaments.filter(tournament => tournament.id !== childRemovedKey);

      // if (newTournaments && newTournaments.length) {
      //   return {
      //     ...state,
      //     tournaments: newTournaments,
      //     hasActiveRegistration//
      //   };
      // }


      newTournaments.sort((a, b) => {
        const aIsRegistration = a.currentState === 'registration';
        const bIsRegistration = b.currentState === 'registration';

        // If one is registration and the other isn't, registration comes first
        if (aIsRegistration && !bIsRegistration) return -1;
        if (!aIsRegistration && bIsRegistration) return 1;

        // Otherwise, sort by startDate (descending)
        return b.startDate - a.startDate;
      });

      return {
        ...state,
        tournaments: newTournaments,
        hasActiveRegistration,
      };
    }

    case 'MY_TOURNAMENTS_DATA': {
      return {
        ...state,
        myTournamentsData: action.data,
      };
    }

    case 'TOURNAMENT_PLAYERS_REPLACE': {
      return {
        ...state,
        tournamentPlayers: action.data,
      };
    }

    case 'TOURNAMENTS_HISTORY_REPLACE':
      // pirmā lapa – aizvietojam visu masīvu
      return {
        ...state,
        tournamentsHistory: Array.isArray(action.data) ? action.data : [],
      };

    case 'TOURNAMENTS_HISTORY_APPEND':
      // nākamā lapa – pieliekam klāt
      return {
        ...state,
        tournamentsHistory: [
          ...(state.tournamentsHistory || []),
          ...(Array.isArray(action.data) ? action.data : []),
        ],
      };


    case 'PLAYER_TOURNAMENTS_HISTORY_REPLACE': {
      return {
        ...state,
        playerTournamentsHistory: action.data,
      };
    }

    case 'PLAYER_TOURNAMENTS_HISTORY_REPLACE_Mobile': {
      return {
        ...state,
        playerTournamentsHistoryMobile: action.data,
      };
    }

    /*  case 'TOURNAMENT_PLAYER_HISTORY': {
      return {
        ...state,
        tournamentPlayerHistory: action.data,
      };
    }  */

    default:
      return state;
  }
}
